import { api } from './index';

const BASE_PATH = '/api/internal/holiday_multipliers';

export type HolidayMultiplier = {
  id: number;
  holidayType: string;
  priceMultiplier: number;
  costMultiplier: number;
  humanHolidayType: string;
}

export interface HolidayMultiplierForm {
  id: number;
  priceMultiplier: number;
  costMultiplier: number;
}

export const holidayMultipliersApi = {
  index(): Promise<Array<HolidayMultiplier>> {
    return api({
      method: 'get',
      url: BASE_PATH,
    }).then(response => response.data.holidayMultipliers);
  },
  showForDate(date: string): Promise<HolidayMultiplier | null> {
    const NO_CONTENT = 204;

    return api({
      method: 'get',
      url: BASE_PATH,
      params: { date },
    }).then(response => response.data?.holidayMultiplier ?? null)
      .catch((error) => {
        if (error?.response?.status === NO_CONTENT) return null;
        throw error;
      });
  },
  update(form: HolidayMultiplierForm): Promise<HolidayMultiplier> {
    return api({
      method: 'put',
      url: `${BASE_PATH}/${form.id}`,
      data: { holidayMultiplier: form },
    }).then(response => response.data.holidayMultiplier);
  },
};
